import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import { useNavigate } from 'react-router-dom';
import APIRequests from '../../../utility/APIRequests';
import Helper1, { capitalizeFirstLetter, notify } from '../../../utility/Helper1';
import { useSelector, useDispatch } from 'react-redux';
import { addUrlToPath } from '../../../utility/Helper1'
import { userSelect, allRemoteSettingsSelect, allLocalSettingsSelect } from '../../../redux/selectors/index';
import { authActions } from '../../../redux/actions';

import { WebLink, SiteWide, Images } from "../../../utility/customComponents";
import LoadingIcon from "../../../utility/customComponents/loader/LoadingIcon";
import ReCAPTCHA from "../../../utility/customComponents/ReCAPTCHA";
import { Mail, Lock, Eye, EyeOff, ArrowLeft, Leaf, CheckCircle2 } from "lucide-react"

import AuthHolder from "./AuthHolder";
import { AiFillCloseCircle, AiOutlineUser, AiOutlineMail, AiOutlineLock, AiOutlineEye, AiOutlineEyeInvisible, AiOutlineGlobal } from "react-icons/ai";


const Signin = () => {

    const dispatch = useDispatch();
    const users = useSelector(userSelect);

    const [email, setEmail] = useState('');
    const [showPassword, setShowPassword] = useState(false)


    const [password, setPassword] = useState('');
    const [loading, changeLoading] = useState(false);
    const [loadingText, setLoadingText] = useState("");
    const [notificationMessage, setNotificationMessage] = useState('');
    const [fullPageLoading, setFullPageLoading] = useState(false);

    const navigate = useNavigate();

    const site_settings = useSelector(allRemoteSettingsSelect);
    const local_settings = useSelector(allLocalSettingsSelect);

    const deleteCookie = (name) => {
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`
    }


    useEffect(() => {
        deleteCookie("news_already_read")
    }, [])


    const [captcha, setCaptcha] = useState(null);

    const captchaHasChanged = (data) => {
        setCaptcha(data)
    }


    const doLogin = async (e) => {

        e.preventDefault();

        if (!captcha && (Number(site_settings?.site_settings?.use_google_reCaptcha) == 1)) { notify('Invalid captcha response', 0); return; }

        setFullPageLoading(true);
        if (loading) { return; }

        changeLoading(true)
        setLoadingText("Authenticating...")

        dispatch(authActions.onLogin("account/login", { username: email, captcha, password: password }, response => {


            if (response.code != 0) {

                if (response.code == 1) {

                    let toThisPlace;

                    if (local_settings?.lastPrivateUrl) {
                        toThisPlace = local_settings?.lastPrivateUrl
                    } else {
                        toThisPlace = '/'
                    }

                    navigate(toThisPlace, { replace: true });

                } else if (response.code === 2) {
                    navigate('/verify-user', { replace: true });
                }

            } else {
                notify(response.msg, response.code)
            }


            changeLoading(false)
            setLoadingText("")

            setFullPageLoading(false);

        }),
        );


    };



    let userLoginStyle = site_settings?.operational_settings?.userLoginStyle
    let userLoginStyleObj = [
        {
            inputType: 'email',
            placeholder: 'Email',
        },
        {
            inputType: 'text',
            placeholder: 'Username',
        }

    ]

    return (<AuthHolder>

        <div className="space-y-1 p-6 pb-4">
            <h2 className="text-2xl font-bold text-center text-green-800">Welcome Back</h2>
            <p className="text-center text-green-600">Sign in to access your account</p>
        </div>

        <div className="p-6 pt-2">
            <form onSubmit={doLogin} className="space-y-4">
                <div className="space-y-2">
                    <label htmlFor="email" className="block text-green-700 font-medium">
                        {capitalizeFirstLetter(userLoginStyleObj?.[userLoginStyle]?.placeholder)}
                    </label>
                    <div className="relative">
                        <Mail className="absolute left-3 top-2.5 h-5 w-5 text-green-500" />
                        <input
                            id="email"
                            type={userLoginStyleObj?.[userLoginStyle]?.inputType}
                            placeholder={userLoginStyleObj?.[userLoginStyle]?.placeholder}
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            className="w-full pl-10 pr-3 py-2 border border-green-200 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-all"
                        />
                    </div>
                </div>

                <div className="space-y-2">
                    <div className="flex justify-between">
                        <label htmlFor="password" className="block text-green-700 font-medium">
                            Password
                        </label>
                        <WebLink
                            href="/reset"
                            className="text-sm text-green-600 hover:text-green-700 hover:underline transition-colors"
                        >
                            Forgot password?
                        </WebLink>
                    </div>
                    <div className="relative">
                        <Lock className="absolute left-3 top-2.5 h-5 w-5 text-green-500" />
                        <input
                            id="password"
                            type={showPassword ? "text" : "password"}
                            placeholder="••••••••"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            className="w-full pl-10 pr-10 py-2 border border-green-200 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-all"
                        />
                        <button
                            type="button"
                            onClick={() => setShowPassword(!showPassword)}
                            className="absolute right-3 top-2.5 text-green-500 hover:text-green-700"
                        >
                            {showPassword ? <EyeOff className="h-5 w-5" /> : <Eye className="h-5 w-5" />}
                            <span className="sr-only">{showPassword ? "Hide password" : "Show password"}</span>
                        </button>
                    </div>
                </div>

                <div className="flex items-center space-x-2 pt-2">
                    <input
                        type="checkbox"
                        id="remember"
                        className="h-4 w-4 rounded border-green-300 text-green-600 focus:ring-green-500"
                    />
                    <label htmlFor="remember" className="text-sm text-green-700 font-normal">
                        Remember me
                    </label>
                </div>

                <div className="pt-2">
                    <ReCAPTCHA onChange={captchaHasChanged} />
                </div>

                <button
                    type="submit"
                    className="w-full bg-green-600 hover:bg-green-700 text-white font-medium py-2.5 px-4 rounded-md transition-all duration-200 shadow-md hover:shadow-lg disabled:opacity-70 disabled:cursor-not-allowed mt-2"
                    disabled={loading}
                >
                    {loading ? (
                        <div className="flex items-center justify-center">
                            <svg
                                className="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                            >
                                <circle
                                    className="opacity-25"
                                    cx="12"
                                    cy="12"
                                    r="10"
                                    stroke="currentColor"
                                    strokeWidth="4"
                                ></circle>
                                <path
                                    className="opacity-75"
                                    fill="currentColor"
                                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                ></path>
                            </svg>
                            Signing in...
                        </div>
                    ) : (
                        "Sign in"
                    )}
                </button>
            </form>
        </div>

        <div className="px-6 pb-6 pt-0">
            <div className="relative w-full my-4">
                <div className="absolute inset-0 flex items-center">
                    <span className="w-full border-t border-green-200" />
                </div>
                <div className="relative flex justify-center text-xs">
                    <span className="bg-white px-2 text-green-600">or</span>
                </div>
            </div>

            <p className="text-center text-sm text-green-700">
                Don't have an account?{" "}
                <WebLink
                    href="/signup"
                    className="font-medium text-green-600 hover:text-green-800 hover:underline transition-colors"
                >
                    Create account
                </WebLink>
            </p>
        </div>


    </AuthHolder>);
};

export default Signin;